import Model from './Model';

export default class Value extends Model {

    id = null;
    key = null;
    ordinal = 0;
    icon = null;
    title = '';
    type = '';
    value = ''; 
    required = false;

    constructor(data = {}) {
        super(data);
        Object.assign(this, data);
    }

    isValidEmail() {
        if (this.value && this.value.length > 0) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(this.value).toLowerCase());
        }
        return true;
    }

    isValidPhone() {
        if (this.value && this.value.length > 0) {
            return /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/.test(this.value);
        }
        return true;
    }

    isValidUrl() {
        if (this.value && this.value.length > 0) {
            return /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(this.value);
        }
        return true;
    }

}